module.exports = __webpack_public_path__ + "static/media/user-img-depoimento-03.7bc98cd5.jpg";